<template>
    <div>
        <div class="tuter_header">
                <div class="title">
                    {{title}}
                </div>
                <div class="tuter_header_right">
                  <div class="search">
                   <div class="inputBlock">
                          <div class="inputBlock_input">
                              <input type="search"
                                     id="search"
                                     :placeholder="placeholder"
                                     v-model="search"
                                     @input="emitMovies()"
                                     @mouseenter="colorInputSvg = true"
                                     @mouseleave="colorInputSvg = false"
                                     @click="colorInputSvg = false"
                              >
                              <div class="input_logo">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <transition name="search">
                                      <path v-if="colorInputSvg === false" d="M7.5 13.5C8.8845 13.5 10.1573 13.0238 11.1728 12.234L14.4697 15.531L15.5303 14.4705L12.2333 11.1735C13.0238 10.1572 13.5 8.8845 13.5 7.5C13.5 4.19175 10.8082 1.5 7.5 1.5C4.19175 1.5 1.5 4.19175 1.5 7.5C1.5 10.8082 4.19175 13.5 7.5 13.5ZM7.5 3C9.98175 3 12 5.01825 12 7.5C12 9.98175 9.98175 12 7.5 12C5.01825 12 3 9.98175 3 7.5C3 5.01825 5.01825 3 7.5 3Z" fill="#C5C5C9"/>
                                      <path v-else d="M7.5 13.5C8.8845 13.5 10.1573 13.0238 11.1728 12.234L14.4697 15.531L15.5303 14.4705L12.2333 11.1735C13.0238 10.1572 13.5 8.8845 13.5 7.5C13.5 4.19175 10.8082 1.5 7.5 1.5C4.19175 1.5 1.5 4.19175 1.5 7.5C1.5 10.8082 4.19175 13.5 7.5 13.5ZM7.5 3C9.98175 3 12 5.01825 12 7.5C12 9.98175 9.98175 12 7.5 12C5.01825 12 3 9.98175 3 7.5C3 5.01825 5.01825 3 7.5 3Z" fill="#ABABB2"/>
                                    </transition>
                                   </svg>
                              </div>

                              <transition name="fade">
                                  <div class="notifications error" >
                                      
                                      <div class="notifications_square">
                                        
                                      </div>
                                  </div>
                              </transition>
                          </div>
                    </div>
                </div>
                <div class="add_tutter" @click="addTuter()">
                  <button class="button">{{buttonName}}</button>
                </div>
                </div>
                
              </div>
    </div>
</template>

<script>
    export default {
        name:'header',
        props:{
            title:[String],
            buttonName:[String],
            placeholder:[String],
            arr:[Array],
            arr1:[Array],
            numberPage:[Number],
            countPage:[Number]
        },
        data(){
            return{
                search:'',
                colorInputSvg:false
            }
        },
        methods:{
            addTuter(){
               this.$emit('addarr')
                
                console.log(this.arr)
                
            },
            emitMovies() {
                this.$emit('arrtuter', this.search)
            },
        },
        computed:{
        },
    }
            
</script>

<style lang="scss" scoped>
@import "../../../styles_fonts.scss";

    $font_Geometria: Geometria, 'Geometria';

    $color_background: #F6F6FB;
    $color_Gray_1: #C5C5C9;
    $color_Gray_2: #ABABB2;
    $color_Gray_3: #EBEBEB;
    $color_black: #333333;
    $color_purple: #8C71FE;
    $color_red: #FF6597;

    .fade-enter-active, .fade-leave-active {
          transition: opacity ease .25s;
      }
      .fade-enter, .fade-leave-to {
          opacity: 0;
      }
      .search-enter-active, .search-leave-active {
          transition: opacity ease .5s;
      }
      .search-enter, .search-leave-to {
          opacity: 0;
      }
    p{
        margin: 0;
        padding: 0;
    }

 .tuter_header{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding:29px 0 24px 0;

                .title{
                  font-family: $font_Geometria;
                  font-style: normal;
                  font-weight: bold;
                  font-size: 22px;
                  line-height: 120%;
                  display: flex;
                  align-items: center;
                  color: #333333;
                  
                }
                .tuter_header_right{
                  display: flex;
                  align-items: flex-end;
                }
                .search{
                  padding-right: 20px;
                }
              }

.inputBlock {
       

        .inputBlock_title {
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 18px;
            color: $color_Gray_1;
            display: flex;
            justify-content: space-between;
        }

        .inputBlock_input {
            display: flex;
            margin-top: 5px;
            position: relative;


        
            input[type=search]{
                font-family:  $font_Geometria;
                height: 40px;
                
                background-color: white;
                border: 1px solid rgba(0, 0, 0, 0.08);
                border-radius: 12px;
                color: $color_black;
                font-size: 15px;
                line-height: 19px;
                display: flex;
                align-items: center;
                padding: 0 72.5px 0 20px;
                font-weight: 400;
                font-style: normal;
                outline: none;
                transition: 0.5s ease;
            }
            input[type=search]:hover{
                border: 1px solid #C5C5C9;
            }
            input[type=search]:focus{
                border: 1px solid  $color_purple;
            }
            

            input::-webkit-search-decoration,
            input::-webkit-search-cancel-button,
            input::-webkit-search-results-button,
            input::-webkit-search-results-decoration { display: none; }
            input:focus {
                border: 1px solid $color_purple;
            }

            .input_logo svg {
                transition: 0.25s ease;
                path {
                    transition: 0.25s ease;
                }
            }

            input[type=search]:focus + .input_logo svg path {
                fill: $color_purple;
            }
            
            
            input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                font-family: $font_Geometria;
                color: $color_Gray_1;
            }
            input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                color: $color_Gray_1;
                                font-family: $font_Geometria;

                opacity: 1;
            }
            input::-moz-placeholder { /* Mozilla Firefox 19+ */
                color: $color_Gray_1;
                                font-family: $font_Geometria;

                opacity: 1;
            }
            input:-ms-input-placeholder { /* Internet Explorer 10-11 */
                color: $color_Gray_1;
                                font-family: $font_Geometria;

            }
            input::-ms-input-placeholder { /* Microsoft Edge */
                color: $color_Gray_1;
                                font-family: $font_Geometria;

            }

            input::placeholder { /* Most modern browsers support this now. */
                color: $color_Gray_1;
                                font-family: $font_Geometria;

            }

            
        }
         .input_logo {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 11px;
            width: 22px;
            height: 100%;
            cursor: text;
        }
   }
   .button{
    background: #8C71FE;;
    border-radius: 8px;
    cursor: pointer;
    border:0;
    outline:0;
    padding:11px 20px 10px 20px;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #FFFFFF;
    transition: 0.5s;

  }
  .button:hover{
      background: #7B61EB;
  }
  button:active {
    background: #6F57D6;
}
</style>